import React, { useEffect, useState } from 'react'

import { Card, Empty } from 'antd'

import { RetweetOutlined } from '@ant-design/icons'

// Store
import { useSelector } from 'react-redux'

import './PatientList.scss'
import { useQuery } from '@apollo/client'
import { PATIENT_LIST } from './connection'
import { useHistory, useLocation } from 'react-router-dom'
import { format } from 'date-fns'
import Search from 'antd/lib/input/Search'
import { SvgInline } from '../../Components/SvgInline/SvgInline'

type SelectorPatientListProps = {
  userInfo: any
  permissions: string[]
  locations: any[]
  token: string
}

type CardType = {
  id: number
  statusId?: number
  statusImage?: string
  Person: {
    firstName: string
    lastName: string
    surName: string
    socialName: string
  }
  PatientLocation: {
    ingressDate: Date
    releaseDate?: Date
    DefReleaseEvent?: {
      id: number
      name: string
    }
    Location: {
      id: number
      code: string
      name: string
    }
  }
  PatientGuardian: {
    Guardian: {
      firstName: string
      lastName: string
      surName: string
      socialName: string
    }
  }
}

function PatientList({ isMobile, exposeSubMenu, setMainLoading, setRightIcon }: any) {
  const { token } = useSelector(
    (state: SelectorPatientListProps) => state
  )
  const history = useHistory()
  const { state } = useLocation<any>()

  const [search, setSearch] = useState<string>(state?.search.replaceAll('.','').split('-')[0] ?? '')
  const [locationId,] = useState<number>()
  const [patientId,] = useState<number>()

  const [individual, ] = useState(!!state?.search)

  const [cards, setCards] = useState<CardType[]>([])
  const [others, setOthers] = useState<CardType[]>([])

  const e_patientList = useQuery(PATIENT_LIST, {
    context: {
      headers: {
        authorization: `Bearer ${token}`
      }
    },
    variables: {
      PatientListInput: {
        search,
        locationId,
        patientId,
        limit: 20
      }
    }
  })

  useEffect(() => {
    setRightIcon({
      icon: <RetweetOutlined style={{ fontSize: 28 }} />,
      onClick: () => {
        setMainLoading(true)
        setTimeout(() => {
          e_patientList.refetch()
          setMainLoading(false)
        }, 1500)
      }
    })
    return () => {
      setRightIcon({})
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setMainLoading(e_patientList.loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [e_patientList.loading])

  useEffect(() => {
    const { data } = e_patientList
    if (data?.PatientList?.success) {
      const _cards = data.PatientList.Patients
      if (individual) {
        const [_current, ..._others] = _cards
        if (_current) {
          setCards([_current])
        }
        if (_others.length) {
          setOthers(_others)
        } 
      } else {
        // Only first occurrence of each patient
        const _cardsUnique = _cards.reduce((acc: any, cur: any) => {
          if (!acc.find((x: any) => x.Person?.id === cur.Person?.id)) {
            acc.push(cur)
          }
          return acc
        }, [])
        setCards(_cardsUnique)
        // setCards(_cards)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [e_patientList.data])

  if (!e_patientList.loading && ((cards.length + others.length) === 0)) {
    return <div className='App'>
      <div className='PatientList'>
        <div className='Wrapper'>
          <Search onSearch={(value) => {
            setSearch(value)
          }} style={{
            marginTop: 16
          }} placeholder="Ingresa un texto para buscar..." enterButton="Buscar" size="large" loading={e_patientList.loading} />
          <Empty style={{
            marginTop: 24
          }} />
        </div>
      </div>
    </div>
  }

  return (
    <div className='App'>
      <div className='PatientList'>
        <div className='Wrapper'>
          <Search onSearch={(value) => {
            setSearch(value)
          }} style={{
            marginTop: 16
          }} placeholder="Ingresa un texto para buscar..." enterButton="Buscar" size="large" loading={e_patientList.loading} />
          {!e_patientList.loading && individual && <h4>Ingresos Activos<br /><small>Activos actualmente.</small></h4>}
          {cards.map(c => <Card
            hoverable
            onClick={() => {
              history.push(`/patient/view/${c?.id}`)
            }}
            style={{ width: '100%', marginTop: 16 }}
            key={`${c?.Person?.firstName}-${c?.Person?.lastName}-${c?.Person?.surName}`}
            className='PatientCard'
          >
            <div className="Icon">
              {c?.statusImage ? <SvgInline url={c?.statusImage} /> : <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M39.1978 4.41667C39.8503 4.41667 40.4965 4.54519 41.0993 4.79489C41.7021 5.04459 42.2499 5.41059 42.7113 5.87198C43.1727 6.33337 43.5387 6.88112 43.7884 7.48396C44.0381 8.08679 44.1666 8.73291 44.1666 9.38542V43.6256C44.1666 44.2781 44.0381 44.9242 43.7884 45.5271C43.5387 46.1299 43.1727 46.6777 42.7113 47.1391C42.2499 47.6005 41.7021 47.9664 41.0993 48.2162C40.4965 48.4659 39.8503 48.5944 39.1978 48.5944H13.802C13.1495 48.5944 12.5034 48.4659 11.9005 48.2162C11.2977 47.9664 10.75 47.6005 10.2886 47.1391C9.82717 46.6777 9.46118 46.1299 9.21148 45.5271C8.96177 44.9242 8.83325 44.2781 8.83325 43.6256V9.38542C8.8331 8.12639 9.3109 6.91424 10.1701 5.99396C11.0293 5.07368 12.2058 4.51388 13.4619 4.42771L13.802 4.41667H39.1978ZM40.8541 35.3333H12.1458V43.6256C12.1458 44.5399 12.8878 45.2819 13.802 45.2819H39.1978C39.6371 45.2819 40.0584 45.1074 40.369 44.7968C40.6796 44.4862 40.8541 44.0649 40.8541 43.6256V35.3333ZM17.1167 38.6458H35.8853C36.305 38.646 36.7089 38.8054 37.0155 39.0919C37.3222 39.3783 37.5086 39.7705 37.5372 40.1892C37.5658 40.6078 37.4344 41.0218 37.1696 41.3473C36.9048 41.6728 36.5263 41.8857 36.1106 41.9429L35.8853 41.9583H17.1167C16.6973 41.9576 16.2937 41.7978 15.9875 41.5112C15.6813 41.2245 15.4952 40.8324 15.4669 40.4139C15.4386 39.9954 15.5702 39.5817 15.835 39.2564C16.0998 38.9312 16.4781 38.7185 16.8937 38.6613L17.1167 38.6458H35.8853H17.1167ZM39.1978 7.72917H13.802L13.5768 7.74462C13.1802 7.79906 12.8168 7.99523 12.5538 8.29686C12.2907 8.59849 12.1458 8.98518 12.1458 9.38542V32.0208H17.6666V27.041C17.6666 25.6122 18.7531 24.4374 20.1443 24.2961L20.427 24.2806H32.5728C34.0016 24.2806 35.1787 25.3671 35.3178 26.7606L35.3333 27.041V32.0208H40.8541V9.38542C40.8541 8.94615 40.6796 8.52488 40.369 8.21427C40.0584 7.90366 39.6371 7.72917 39.1978 7.72917ZM32.0208 27.5931H20.9791V32.0208H32.0208V27.5931ZM26.4999 11.0306C27.9641 11.0306 29.3684 11.6123 30.4037 12.6476C31.4391 13.683 32.0208 15.0872 32.0208 16.5515C32.0208 18.0157 31.4391 19.4199 30.4037 20.4553C29.3684 21.4906 27.9641 22.0723 26.4999 22.0723C25.0357 22.0723 23.6315 21.4906 22.5961 20.4553C21.5607 19.4199 20.9791 18.0157 20.9791 16.5515C20.9791 15.0872 21.5607 13.683 22.5961 12.6476C23.6315 11.6123 25.0357 11.0306 26.4999 11.0306ZM26.4999 14.3431C25.9142 14.3431 25.3525 14.5758 24.9384 14.9899C24.5242 15.4041 24.2916 15.9658 24.2916 16.5515C24.2916 17.1371 24.5242 17.6988 24.9384 18.113C25.3525 18.5271 25.9142 18.7598 26.4999 18.7598C27.0856 18.7598 27.6473 18.5271 28.0614 18.113C28.4756 17.6988 28.7083 17.1371 28.7083 16.5515C28.7083 15.9658 28.4756 15.4041 28.0614 14.9899C27.6473 14.5758 27.0856 14.3431 26.4999 14.3431Z" fill="#0069B8"/>
              </svg>}
            </div>

            <div className="CardContent">
              <div className="CardContent-title">
                {c?.Person?.firstName} {c?.Person?.lastName} {c?.Person?.surName}
              </div>
              <div className="CardContent-description">
                Ubicación: {c?.PatientLocation?.Location?.code}
              </div>
            </div>
          </Card>)}

          {!e_patientList.loading && individual && others.length > 0 && <h4 className='Others'>Ingresos anteriores<br /><small>Registro histórico.</small></h4>}
          {others.map(c => <Card
            style={{ width: '100%', marginTop: 16, opacity: 0.5 }}
            key={`${c?.Person?.firstName}-${c?.Person?.lastName}-${c?.Person?.surName}`}
            className='PatientCard PatientCard__disabled'
          >
            <div className="Icon">
              <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M39.1978 4.41667C39.8503 4.41667 40.4965 4.54519 41.0993 4.79489C41.7021 5.04459 42.2499 5.41059 42.7113 5.87198C43.1727 6.33337 43.5387 6.88112 43.7884 7.48396C44.0381 8.08679 44.1666 8.73291 44.1666 9.38542V43.6256C44.1666 44.2781 44.0381 44.9242 43.7884 45.5271C43.5387 46.1299 43.1727 46.6777 42.7113 47.1391C42.2499 47.6005 41.7021 47.9664 41.0993 48.2162C40.4965 48.4659 39.8503 48.5944 39.1978 48.5944H13.802C13.1495 48.5944 12.5034 48.4659 11.9005 48.2162C11.2977 47.9664 10.75 47.6005 10.2886 47.1391C9.82717 46.6777 9.46118 46.1299 9.21148 45.5271C8.96177 44.9242 8.83325 44.2781 8.83325 43.6256V9.38542C8.8331 8.12639 9.3109 6.91424 10.1701 5.99396C11.0293 5.07368 12.2058 4.51388 13.4619 4.42771L13.802 4.41667H39.1978ZM40.8541 35.3333H12.1458V43.6256C12.1458 44.5399 12.8878 45.2819 13.802 45.2819H39.1978C39.6371 45.2819 40.0584 45.1074 40.369 44.7968C40.6796 44.4862 40.8541 44.0649 40.8541 43.6256V35.3333ZM17.1167 38.6458H35.8853C36.305 38.646 36.7089 38.8054 37.0155 39.0919C37.3222 39.3783 37.5086 39.7705 37.5372 40.1892C37.5658 40.6078 37.4344 41.0218 37.1696 41.3473C36.9048 41.6728 36.5263 41.8857 36.1106 41.9429L35.8853 41.9583H17.1167C16.6973 41.9576 16.2937 41.7978 15.9875 41.5112C15.6813 41.2245 15.4952 40.8324 15.4669 40.4139C15.4386 39.9954 15.5702 39.5817 15.835 39.2564C16.0998 38.9312 16.4781 38.7185 16.8937 38.6613L17.1167 38.6458H35.8853H17.1167ZM39.1978 7.72917H13.802L13.5768 7.74462C13.1802 7.79906 12.8168 7.99523 12.5538 8.29686C12.2907 8.59849 12.1458 8.98518 12.1458 9.38542V32.0208H17.6666V27.041C17.6666 25.6122 18.7531 24.4374 20.1443 24.2961L20.427 24.2806H32.5728C34.0016 24.2806 35.1787 25.3671 35.3178 26.7606L35.3333 27.041V32.0208H40.8541V9.38542C40.8541 8.94615 40.6796 8.52488 40.369 8.21427C40.0584 7.90366 39.6371 7.72917 39.1978 7.72917ZM32.0208 27.5931H20.9791V32.0208H32.0208V27.5931ZM26.4999 11.0306C27.9641 11.0306 29.3684 11.6123 30.4037 12.6476C31.4391 13.683 32.0208 15.0872 32.0208 16.5515C32.0208 18.0157 31.4391 19.4199 30.4037 20.4553C29.3684 21.4906 27.9641 22.0723 26.4999 22.0723C25.0357 22.0723 23.6315 21.4906 22.5961 20.4553C21.5607 19.4199 20.9791 18.0157 20.9791 16.5515C20.9791 15.0872 21.5607 13.683 22.5961 12.6476C23.6315 11.6123 25.0357 11.0306 26.4999 11.0306ZM26.4999 14.3431C25.9142 14.3431 25.3525 14.5758 24.9384 14.9899C24.5242 15.4041 24.2916 15.9658 24.2916 16.5515C24.2916 17.1371 24.5242 17.6988 24.9384 18.113C25.3525 18.5271 25.9142 18.7598 26.4999 18.7598C27.0856 18.7598 27.6473 18.5271 28.0614 18.113C28.4756 17.6988 28.7083 17.1371 28.7083 16.5515C28.7083 15.9658 28.4756 15.4041 28.0614 14.9899C27.6473 14.5758 27.0856 14.3431 26.4999 14.3431Z" fill="#000000"/>
              </svg>
            </div>

            <div className="CardContent">
              <div className="CardContent-title">
                {c?.Person?.firstName} {c?.Person?.lastName} {c?.Person?.surName}
              </div>
              <div className="CardContent-description">
                Ubicación: {c?.PatientLocation?.Location.code}
              </div>
              <div className="CardContent-description">
                Fecha de Alta: {format(new Date(c?.PatientLocation.releaseDate || new Date()), 'dd/MM/yyyy')}
              </div>  
            </div>
          </Card>)}

        </div>
      </div>
    </div>
  )
}

export default PatientList
